<template>
	<div class="dialog_scroll dialog_padding clearfix">
		<div class="center_tables center_labtables clearfix">
			<emptymain slot='empty' :emptylist='datalist'></emptymain>
			<div class="exam_vr_info_it" v-for="item in datalist">
				<img src="@/images/exam_vr_info_itback.png" class="exam_vr_info_itback" />
				<div class="exam_vr_info_it_state" v-if='item.commitState == 1'>
					<span v-if='item.commitState == 1'>已提交</span>
					<span v-if='item.commitState == 2'>未提交</span>
				</div>
				<div class="exam_vr_info_itP1 text-ellipsis">
					{{item.name}}
				</div>
				<div class="exam_vr_info_itP2 text-ellipsis">
					<span v-if='item.commitState == 1'>得分：{{item.score}}</span>
					<span v-if='item.commitState == 2'>未提交</span>
				</div>
				<div @click='scoreSimulation(item)' :class="getDisabldVr()?'disabled':''" class="exam_vr_info_itP3" v-if='item.commitState == 1'>
					查看成绩
				</div>
				<div @click='startVrExam(item)' :class="getDisabldVrIn()?'disabled':''" class="exam_vr_info_itP4" v-if='item.commitState == 2'>
					开始实验
				</div>
			</div>
		</div>
		<el-dialog title="考核操作详情" class="open_dialogInfo" :visible.sync="viewShow" :append-to-body='true' width="1100px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="open_dialogTable">
				<el-table :data="viewForm" :row-class-name="tableRowClassName" height="500" border v-if="viewShow && viewForm && viewType=='1'">
					<el-table-column prop="number" label="步骤序号" align='center' width="50" />
					<el-table-column prop="title" label="步骤名称" align='center' show-overflow-tooltip width="200" />
					<el-table-column label="得分/满分" align='center' width="100">
						<template slot-scope="scope">
							{{scope.row.score || 0}} / {{scope.row.zfs}}
						</template>
					</el-table-column>
					<el-table-column prop="jgfs" label="及格分数" align='center'>
					</el-table-column>
					<el-table-column prop="createtime" label="操作时间" align='center' width="200">
					</el-table-column>
					<el-table-column prop="useOp" label="我的选项" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.useOp || '-'}}
						</template>
					</el-table-column>
					<el-table-column prop="zqda" label="正确选项" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.zqda || '-'}}
						</template>
					</el-table-column>
				</el-table>
				<el-table :data="viewForm" :row-class-name="tableRowClassName" height="500" border v-if="viewShow && viewForm && viewType=='2'">
					<el-table-column prop="seq" label="步骤序号" align='center' width="50" />
					<el-table-column prop="title" label="步骤名称" align='center' show-overflow-tooltip width="200" />
					<el-table-column label="得分/满分" align='center'>
						<template slot-scope="scope">
							{{scope.row.score || 0}} / {{scope.row.maxScore}}
						</template>
					</el-table-column>
					<el-table-column label="操作时间" align='center' width="200">
						<template slot-scope="scope">
							<span v-if="scope.row.timeUsed == 0">
							未作答
						</span>
							<span v-if="scope.row.timeUsed != 0">
							{{scope.row.startTime}} - {{scope.row.endTime}}
						</span>
						</template>
					</el-table-column>
					<el-table-column label="用时/规定用时" align='center' width="150">
						<template slot-scope="scope">
							{{scope.row.timeUsed}}秒 / {{scope.row.expectTime || 0}}秒
						</template>
					</el-table-column>
					<el-table-column prop="repeatCount" label="操作次数" align='center' />
					<el-table-column prop="evaluation" label="步骤评价" align='center' show-overflow-tooltip/>
					<el-table-column prop="scoringModel" label="赋分模型" align='center' show-overflow-tooltip/>
					<el-table-column prop="remarks" label="备注" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.remarks || '-'}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="center_btns">
				<el-button type='primary' @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { vrExamineStudentExtract, vrExamineDataIsCommit, vrExaminePaperUserInit, getresult, userDataStepList } from '@/api/vrExamUser.js'
	export default {
		props: {
			vrExamineId: String,
			vrExamineInfo: Object
		},
		data() {
			return {
				datalist: [],

				//考核详情
				viewType: '',
				viewShow: false,
				viewForm: [],
			}
		},
		created() {
			this.getTaskitem();
		},
		methods: {
			getDisabldVrIn() {
				if(this.vrExamineInfo.startTime && this.vrExamineInfo.endTime) {
					var nowTime = new Date();
					var startTime = new Date(this.vrExamineInfo.startTime);
					var endTime = new Date(this.vrExamineInfo.endTime);
					if(nowTime > startTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			getDisabldVr() {
				if(this.vrExamineInfo.startTime && this.vrExamineInfo.endTime) {
					var nowTime = new Date();
					var endTime = new Date(this.vrExamineInfo.endTime);
					if(nowTime > endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if(rowIndex % 2 == 0) {
					return 'warning-row';
				} else {
					return 'success-row';
				}
			},
			scoreSimulation(item) {
				if(this.vrExamineInfo.startTime && this.vrExamineInfo.endTime) {
					var nowTime = new Date();
					var endTime = new Date(this.vrExamineInfo.endTime);
					if(nowTime > endTime) {

					} else {
						return
					}
				} else {
					return
				}
				if(item.version == '1.0.0') {
					getresult({
						paperId: item.paperId
					}).then(res => {
						if(res.code == "OK") {
							this.viewType = '1';
							this.viewForm = res.data.list;
							this.viewShow = true;
						}
					})
				}
				if(item.version == '2.0.0') {
					userDataStepList({
						dataId: item.dataId
					}).then(res => {
						if(res.code == "OK") {
							this.viewType = '2';
							this.viewForm = res.data;
							this.viewShow = true;
						}
					})
				}
			},
			startVrExam(item) {
				if(this.vrExamineInfo.startTime && this.vrExamineInfo.endTime) {
					var nowTime = new Date();
					var startTime = new Date(this.vrExamineInfo.startTime);
					var endTime = new Date(this.vrExamineInfo.endTime);
					if(nowTime > startTime && nowTime < endTime) {

					} else {
						return
					}
				} else {
					return
				}
				if(item.version == '1.0.0') {
					vrExaminePaperUserInit({
						vrDetailId: item.vrDetailId,
						resourceId: item.resourceId,
						vrExamineId: this.vrExamineId,
					}).then(res => {
						if(res.data) {
							this.$emit('startVrExam');
							window.open('#/vrexamdetail?type=index&vrDetailId=' + item.vrDetailId + '&resourceId=' + item.resourceId + '&pid=' + res.data)
						} else {
							this.$message({
								type: 'error',
								message: '您已提交 请勿重新实验！'
							})
						}
					})
				}
				if(item.version == '2.0.0') {
					vrExamineDataIsCommit({
						vrDetailId: item.vrDetailId,
						resourceId: item.resourceId,
						vrExamineId: this.vrExamineId,
					}).then(res => {
						if(res.data) {
							this.$emit('startVrExam');
							window.open('#/vrexamdetail?type=exam&vrDetailId=' + item.vrDetailId + '&resourceId=' + item.resourceId + '&pid=' + this.vrExamineId)
						} else {
							this.$message({
								type: 'error',
								message: '您已提交 请勿重新实验！'
							})
						}
					})
				}
			},
			getTaskitem() {
				vrExamineStudentExtract({
					vrExamineId: this.vrExamineId
				}).then(res => {
					this.datalist = res.data || []
				})
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
	}
</script>